<template>
    <seccion-datos :titulo="provs" :botonGuardar="false" tipo="secondary">
        <div v-if="sistema=='IPAS_WS'" style="align-items: start;" class="row">
            <div class="col-md-5">
                <div style="gap: 15px;" class="row">
                    <input title='Cuando se crea una visita confirmada, se envía a la compañía.' type="checkbox" v-model="auto_cita" @change="cambiar('ipasws_auto_cita', auto_cita)" v-bind:true-value="1" v-bind:false-value="0">
                    <label title='Cuando se crea una visita confirmada, se envía a la compañía.' style="margin: 0;" for="">Cita</label>
                    <input title='Si la cita anotada es superior a los plazos acordados, se indicará por defecto que es a petición de asegurado/perjudicado' type="checkbox" v-model="peticion_asegurado" @change="cambiar('ipasws_peticion_asegurado_cita', peticion_asegurado)" v-bind:true-value="1" v-bind:false-value="0">
                    <label title='Si la cita anotada es superior a los plazos acordados, se indicará por defecto que es a petición de asegurado/perjudicado' style="margin: 0;" for="">Petición Asegurado</label>
                </div>
                <div title='Cuando se requiere la hoja de encargo, se agrega en la descripción de la visita la adventencia de firmarla' style="gap: 15px;" class="row">
                    <input type="checkbox" @change="cambiar('ipasws_texto_encargo', ipasws_texto_cita)" v-model="ipasws_texto_cita" v-bind:true-value="1" v-bind:false-value="0">
                    <label style="margin: 0;" for="">Texto Cita Hoja Encargo</label>
                </div>
            </div>
            <div class="col-md-4" style="display: grid; align-items: start;">
                <div title='Cuando se crea marca (Estoy en domicilio), se envía a la compañía.' style="gap: 15px;" class="row">
                    <input type="checkbox" @change="cambiar('ipasws_auto_domicilio', confirma_cita)" v-model="confirma_cita" v-bind:true-value="1" v-bind:false-value="0">
                    <label style="margin: 0;" for="">Confirma Cita</label>
                </div>
            </div>
            <div class="col-md-3" style="display: grid; align-items: start;">
                <div title='Indica el nº de fotos que se envían al finalizar la visita.' style="gap: 15px;" class="row">
                    <input type="checkbox" @change="cambiar('ipasws_auto_fotos', auto_fotos)" v-model="auto_fotos" v-bind:true-value="1" v-bind:false-value="0">
                    <label style="margin: 0;" for="">Fotos</label>
                    <select @change="cambiar('ipasws_auto_fotos_n', auto_fotos_n)" style="width: auto;" v-model="auto_fotos_n" class="form-control form-control-sm" name="" id="">
                        <option :value="n" v-for="n in numeros" :key="n">{{ n }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div style="margin-left: 20px; justify-content: space-between;" class="row" v-if="sistema=='GENERALI'">
            <div title='Cuando se crea una visita confirmada, se envía a la compañía.' class="row" style="gap: 15px; justify-content: center; align-items: center;">
                <input type="checkbox" v-model="cita_generali" @change="cambiarCitaGenerali()" v-bind:true-value="1" v-bind:false-value="0">
                <label for="" style="margin: 0;">Cita</label>
            </div>
            <div class="row">
                <button class="btn btn-light" style="margin: 1px solid grey;" @click="mostrar_gremios_relacionados = true">Gremios relacionados</button>
            </div>
        </div>
        <Dialog :style="{ width: '40rem' }" header="Gremios relacionados" modal
            v-model:visible="mostrar_gremios_relacionados">
            <div style="display: grid; gap: 2px;">
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 2px; height: 35px;">
                    <div style="display: flex; align-items: center;">
                        <label for="" style="margin:0">Espacialidad PWGS</label>
                    </div>
                    <div style="display: flex; align-items: center;">
                        <label for="" style="margin:0">Gremio GENERALI</label>
                    </div>
                </div>
                <div v-for="especialidad in especialidades" :key="especialidad.id" style="display: grid; grid-template-columns: 1fr 1fr; gap: 2px; height: 35px;">
                    <div style="background-color: #F1F1F1; display: flex; align-items: center;">
                        <p style="margin-bottom: 0; margin-left: 5px;">
                            {{ especialidad.nombre.toUpperCase() }}
                        </p>
                    </div>
                    <div style="background-color: #F1F1F1; display: flex; align-items: center;">
                        <select @change="cambioGremioRelacionado(especialidad.id)" v-model="gremios_relacionados[especialidad.id]" class="form-control form-control-sm" style="width: auto; margin-left: 5px;" name="" id="">
                            <option value="" disabled></option>
                            <option :value="gremio.id" v-for="gremio in gremios" :key="gremio.id">{{ gremio.nombre }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </Dialog>
    </seccion-datos>
</template>
<script>
import Dialog from 'primevue/dialog';
import { PwgsApi } from '../../../../../services/PwgsApi';
export default {
    components: {
        Dialog
    },
    props: {
        datos: {
            type: Object
        },
        id:{
            default: 0,
        }
    },
    data() {
        return  {
            gremios:[
                {id:'AL', nombre:'Albañilería'},
                {id:'CA', nombre:'Carpintería'},
                {id:'CE', nombre:'Cerrajería'},
                {id:'EL', nombre:'Electricidad'},
                {id:'FO', nombre:'Fontanería'},
                {id:'PI', nombre:'Pintura'},
                {id:'PQ', nombre:'Parqué'},
                {id:'PO', nombre:'Pocería/Desatranco'},
                {id:'OT', nombre:'Otros Gremios Especialistas'},
            ],
            texto_cita:0,
            numeros:[],
            ipasws_texto_cita:0,
            auto_fotos_n:0,
            auto_fotos:0,
            confirma_cita:0,
            peticion_asegurado:0,
            auto_cita:0,
            provs:'',
            sistema:'',
            cita_generali:0,
            mostrar_gremios_relacionados:false,
            gremios_relacionados:[],
        }
    },
    mounted(){
        this.cargarDatos();
    },
    watch: {
        datos(){
            this.cargarDatos();
        },
        id(){
            this.cargarDatos();
        }
    },
    methods: {
        async cambioGremioRelacionado(especialidad){
            const api = new PwgsApi();
            try{
                await api.put('companias/'+this.datos.idcompañia+'/relacion-gremio-generali/'+especialidad, {id_gremio:this.gremios_relacionados[especialidad]});
            }catch(error){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo cambiar el gremio', life: 5000 });
            }

        },
        async cargarDatos(){
            const api = new PwgsApi();
            this.sistema = this.datos.sistema_compannia;
            if(this.datos.sistema_compannia == 'IPAS_WS'){
                this.provs = 'Envíos automáticos IPAS WS';
                for(let i = 1; i < 16; i++){
                    this.numeros.push(i);
                }
                this.auto_cita = this.datos.ipasws_auto_cita;
                this.peticion_asegurado = this.datos.ipasws_peticion_asegurado_cita;
                this.confirma_cita = this.datos.ipasws_auto_domicilio;
                this.auto_fotos = this.datos.ipasws_auto_fotos;
                this.auto_fotos_n = this.datos.ipasws_auto_fotos_n;
                this.ipasws_texto_cita = this.datos.ipasws_texto_encargo;
            }else if(this.datos.sistema_compannia == 'GENERALI'){
                var esp = await api.get('especialidades');
                esp.datos = esp.datos.sort((a, b) => a.nombre.localeCompare(b.nombre));
                this.especialidades = esp.datos;
                var relaciones = await api.get('companias/' + this.datos.idcompañia + '/relacion-gremios-generali');
                Object.entries(relaciones).forEach(([key, value]) => {
                    this.gremios_relacionados[key] = value;
                })
                console.log('relaciones', relaciones);
                this.provs = 'Envíos automáticos a COMPAÑÍA';
                this.cita_generali = this.datos.companyia_envio_auto_cita;
            }
        },
        async cambiar(campo, valor) {
            try{
                const api = new PwgsApi();
                await api.put('companias/'+this.datos.idcompañia, {[campo]:valor});
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
            }catch(error){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async cambiarCitaGenerali(){
            const api = new PwgsApi;
            await api.put('companias/'+this.datos.idcompañia, {companyia_envio_auto_cita:this.cita_generali});
        },
    },
}
</script>